export default "__VITE_ASSET__pR5GyfTn__"